import { render, staticRenderFns } from "./shopscategory.vue?vue&type=template&id=aa24a10e&"
import script from "./shopscategory.vue?vue&type=script&lang=js&"
export * from "./shopscategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports